<template>
    <table class="checkout__totals">                                        
        <tbody class="checkout__totals-subtotals">
            <tr>
                <th>Subtotal</th>
                <td class='notranslate'>{{toUSD(totals[0].subtotal)}}</td>
            </tr>
            <tr v-if="totals[0].coretotal > 0">
                <th>Core Charges</th>
                <td class='notranslate'>{{toUSD(totals[0].coretotal)}}</td>
            </tr>
            <tr v-if="totals[0].shippingtotal > 0">
                <th>Shipping</th>
                <td class='notranslate'>{{toUSD(totals[0].shippingtotal)}}</td>
            </tr>
            <tr>
                <td><div class="block-space--layout--divider-5"></div></td>
                <td> </td>
            </tr>
            <tr v-for="promo in promos_format" :key="promo.code">
                <td>
                    <strong>{{promo.title}}:</strong>
                    <br><div class="text-promotion-applied-total">{{promo.desc}}</div>
                </td>
                <td class='notranslate'>- {{toUSD(promo.amnt_dc)}}</td>
            </tr>
            <tr v-if="totals[0].taxtotal > 0">
                <th>Estimated Tax</th>
                <td class='notranslate'>{{toUSD(totals[0].taxtotal)}}</td>
            </tr>
        </tbody>
        <tfoot class="checkout__totals-footer">
            <tr>
                <th>Total</th>
                <td class='notranslate'>{{toUSD(totals[0].ordertotal)}}</td>
            </tr>
        </tfoot>
    </table>
</template>

<script>
import { mapGetters } from 'vuex';
import Price from '../../../mixins/price.js';

export default {
    mixins: [Price],
    data() {
        return {
            // subtotal        : '319.99',
            // cor_changes     : '22.99',
            // shipping        : '25.00',
            // grandtotal      : '366.53',
        };
    },

    computed: {
        ...mapGetters("cart", [
            "totals",
            "promo_code"
        ]),

        promos_format() {
            const promos = [];
            
            this.promo_code.forEach(p => {
                p.title = 'Promotional Discount';

                if(p.to_item != ""){
                    p.title = 'Promotional Item Discount';
                }

                if(p.to_sag != ""){
                    p.title = 'Promotional Sales Category Discount';
                }
                promos.push(p);
            });

            return promos;
        }
    },

    methods: {

    },

    updated() {
        // console.log(this.totals);
    },

    created() {
        
        console.table(this.promo_code);
    }

}
</script>